import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchAuthMe } from "../../../api/requests/auth-requests";

export const useSettingsAuth = () => {
    const [currentUser, setCurrentUser] = useState(null);
    const [companyId, setCompanyId] = useState(null);
    const [companyCode, setCompanyCode] = useState(null);
    const [pageLoading, setPageLoading] = useState(true);
    const [isCorporate, setIsCorporate] = useState(true);

    const navigate = useNavigate();

    // Rolleri hesapla
    const userRoles = currentUser?.data?.roles || [];
    const canViewAll = userRoles.includes("ROLE_SUPER_ADMIN") || userRoles.includes("ROLE_COMPANY_ADMIN");
    const isAccountant = userRoles.includes("ROLE_COMPANY_ACCOUNTANT");
    // Resmî tatil takvimi ulusaldır, firma verisi değildir: yalnız süper admin yönetir.
    const isSuperAdmin = userRoles.includes("ROLE_SUPER_ADMIN");

    useEffect(() => {
        const getUserInfo = async () => {

            try {
                setPageLoading(true);

                const res = await fetchAuthMe();

                // HTTP auth fail
                if (res.status === 401 || res.status === 403) {
                    navigate("/login");
                    return;
                }

                const userData = await res.json();

                if (res.ok && userData?.data) {
                    setCurrentUser(userData);
                    setCompanyId(userData.data.companyId);
                    setCompanyCode(userData.data.companyCode);
                } else {
                    toast.error(userData?.message || "Kullanıcı bilgileri alınamadı");
                }

            } catch (error) {
                console.error("Auth error:", error);
                toast.error("Bağlantı hatası");
            } finally {
                setPageLoading(false);
            }
        };

        getUserInfo();
    }, [navigate]);

    return {
        currentUser,
        companyId,
        companyCode,
        pageLoading,
        isCorporate,
        setIsCorporate,
        canViewAll,
        isAccountant,
        isSuperAdmin
    };
};